(function () {
  var header = document.querySelector('[data-section-type="header"]');
  if (header) {
    document.documentElement.style.setProperty(
      "--height-header",
      header.offsetHeight + "px",
    );
    if (document.querySelector("[data-zuber-header]")) {
      header
        .closest(".shopify-section")
        ?.classList.add("zuber-header-above-banner");
    }
  }
})();

(function () {
  var input = document.querySelector("[data-js-search-input]");
  var resultsPanel = document.querySelector("[data-js-search-results]");
  var defaultPanel = document.querySelector("[data-js-search-default]");
  var liveResults = document.querySelector("[data-js-search-live-results]");
  var overlay = document.getElementById("search-results-overlay-desktop");

  if (!input || !resultsPanel) return;

  var basePlaceholder =
    input.getAttribute("placeholder") || "Ürün veya kategori ara...";
  var searchTimeout = null;
  var currentRequestQuery = "";

  function openPanel() {
    resultsPanel.classList.add("is-active");
    resultsPanel.style.setProperty("display", "block", "important");
    if (overlay) {
      overlay.style.display = "block";
      overlay.classList.add("active");
    }
  }

  function closePanel() {
    resultsPanel.classList.remove("is-active");
    resultsPanel.style.removeProperty("display");
    if (overlay) {
      overlay.style.display = "none";
      overlay.classList.remove("active");
    }
  }

  function showDefaultPanel() {
    if (defaultPanel) defaultPanel.style.display = "";
    if (liveResults) {
      liveResults.style.display = "none";
      liveResults.innerHTML = "";
    }
  }

  function showLivePanel() {
    if (defaultPanel) defaultPanel.style.display = "none";
    if (liveResults) liveResults.style.display = "";
  }

  function escapeHtml(value) {
    var div = document.createElement("div");
    div.textContent = value || "";
    return div.innerHTML;
  }

  function renderLiveResults(data) {
    if (!liveResults) return;

    var products =
      (data.resources &&
        data.resources.results &&
        data.resources.results.products) ||
      [];
    var queries =
      (data.resources &&
        data.resources.results &&
        data.resources.results.queries) ||
      [];

    if (!products.length && !queries.length) {
      liveResults.innerHTML =
        '<p class="zuber-search-panel__empty">Sonuç bulunamadı.</p>';
      return;
    }

    var html = "";

    if (queries.length) {
      html += '<div class="zuber-search-panel__section">';
      html += '<p class="zuber-search-panel__title">Öneriler</p>';
      html += '<div class="zuber-search-panel__queries">';
      queries.forEach(function (q) {
        html +=
          '<a href="' +
          q.url +
          '" class="zuber-search-query">' +
          (q.styled_text || escapeHtml(q.text)) +
          "</a>";
      });
      html += "</div></div>";
    }

    if (products.length) {
      html += '<div class="zuber-search-panel__section">';
      html += '<p class="zuber-search-panel__title">Ürünler</p>';
      html += '<div class="zuber-search-panel__products-grid">';
      products.forEach(function (p) {
        html += '<a href="' + p.url + '" class="zuber-search-product-card">';
        html += '<span class="zuber-search-product-card__image">';
        if (p.featured_image && p.featured_image.url) {
          var imgUrl = p.featured_image.url;
          // Shopify CDN boyutlandırma: _720x720 ekle
          imgUrl = imgUrl
            .replace(/(_\d+x\d*|_\d*x\d+)(\.jpg|\.png|\.webp|\.gif)/i, "$2")
            .replace(/(\.jpg|\.png|\.webp|\.gif)(\?.*)?$/i, "_720x720$1$2");
          html +=
            '<img src="' +
            imgUrl +
            '" alt="' +
            escapeHtml(p.title) +
            '" loading="lazy">';
        }
        html += "</span>";
        html +=
          '<span class="zuber-search-product-card__title">' +
          escapeHtml(p.title) +
          "</span>";
        html += '<span class="zuber-search-product-card__price">';

        var compareField =
          p.compare_at_price_min ||
          p.compare_at_price_max ||
          p.compare_at_price ||
          "";

        if (
          compareField &&
          compareField !== "undefined" &&
          compareField !== ""
        ) {
          var numPrice = p.price ? Number(p.price.replace(/[^0-9]/g, "")) : 0;
          var numCompare = Number(compareField.replace(/[^0-9]/g, "")) || 0;

          if (numCompare > numPrice && numCompare > 0) {
            html +=
              '<span class="zuber-search-product-card__price-compare">' +
              compareField +
              "</span>";
            html +=
              '<span class="zuber-search-product-card__price-sale">' +
              p.price +
              "</span>";
          } else {
            html +=
              '<span class="zuber-search-product-card__price-regular">' +
              p.price +
              "</span>";
          }
        } else {
          html +=
            '<span class="zuber-search-product-card__price-regular">' +
            p.price +
            "</span>";
        }

        html += "</span>";
        html += "</a>";
      });
      html += "</div></div>";
    }

    liveResults.innerHTML = html;
  }

  function fetchSuggestions(query) {
    if (liveResults) {
      liveResults.innerHTML =
        '<p class="zuber-search-panel__loading">Aranıyor...</p>';
    }

    fetch(
      "/search/suggest.json?q=" +
        encodeURIComponent(query) +
        "&resources[type]=product,query&resources[limit]=8&resources[options][unavailable_products]=last",
    )
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (input.value.trim() !== currentRequestQuery) return;
        renderLiveResults(data);
      })
      .catch(function () {
        if (liveResults) {
          liveResults.innerHTML =
            '<p class="zuber-search-panel__empty">Bir hata oluştu, tekrar deneyin.</p>';
        }
      });
  }

  input.addEventListener("focus", function () {
    openPanel();
    var query = input.value.trim();
    if (query.length >= 2) {
      showLivePanel();
    } else {
      showDefaultPanel();
    }
  });

  input.addEventListener("input", function () {
    var query = input.value.trim();

    clearTimeout(searchTimeout);

    if (query.length < 2) {
      showDefaultPanel();
      return;
    }

    showLivePanel();
    searchTimeout = setTimeout(function () {
      currentRequestQuery = query;
      fetchSuggestions(query);
    }, 250);
  });

  document.addEventListener("click", function (e) {
    if (!resultsPanel.contains(e.target) && e.target !== input) {
      closePanel();
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      closePanel();
    }
  });

  var placeholderWords = window.zuberSearchKeywords || [];
  if (placeholderWords.length) {
    var placeholderIndex = 0;
    setInterval(function () {
      if (document.activeElement === input) return;
      placeholderIndex = (placeholderIndex + 1) % placeholderWords.length;
      input.setAttribute(
        "placeholder",
        placeholderWords[placeholderIndex] + " ara...",
      );
    }, 2500);
  } else {
    input.setAttribute("placeholder", basePlaceholder);
  }
})();
